import { ListItemIcon, ListItemText, Menu, MenuItem } from "@mui/material";
import React, { useCallback } from "react";
import TuneIcon from "@mui/icons-material/Tune";
import { PrimaryButton } from "../../../../common/components/CustomButton";
import OpenInFullIcon from "@mui/icons-material/OpenInFull";
import { getPathWithParameters, PATH } from "../../../../router-path";
import { Tender } from "../../../tender_page/tender.module";
import { useNavigate } from "react-router-dom";
import { ShowHideProvisionColumnsButton } from "../../../../common/components/ShowHideProvisionColumnsButton/ShowHideProvisionColumnsButton";
import { Column } from "../../../../common/components/ColumnsSelector/ColumnsSelector";
import { ColumnIds } from "../../hooks/columns/common";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";

export interface DisplayMenuProps {
	tender?: Tender;
	availableColumns: Column<ColumnIds>[];
	selectedColumns: Column<ColumnIds>[];
	onColumnToggled: (column: Column<ColumnIds>) => void;
	showHiddenRows: boolean;
	toggleShowHiddenRows: () => void;
}

export function DisplayMenu(props: Readonly<DisplayMenuProps>) {
	const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
	const open = Boolean(anchorEl);
	const navigate = useNavigate();
	const handleClick = (event: React.MouseEvent<HTMLElement>) => {
		setAnchorEl(event.currentTarget);
	};
	const handleClose = () => {
		setAnchorEl(null);
	};

	let pageUrl = `${getPathWithParameters(PATH.MAXIMIZED_TENDER_PRICING_RUN, {
		tenderId: props.tender?.id,
	})}`;

	if (location.pathname.includes("/maximized")) {
		pageUrl = `${getPathWithParameters(PATH.TENDER_PRICING_RUN, {
			tenderId: props.tender?.id,
		})}`;
	}

	const onToggleHiddenRows = useCallback(() => {
		handleClose();
		props.toggleShowHiddenRows();
	}, [handleClose, props.toggleShowHiddenRows]);

	return (
		<div>
			<PrimaryButton
				type="button"
				color="secondary"
				onClick={handleClick}
				startIcon={<TuneIcon />}
				text="Display Settings"
			></PrimaryButton>
			<Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
				{props.tender &&
					<MenuItem
						type="button"
						color="secondary"
						id="column-maximized-button"
						role="link"
						href={pageUrl}
						onClick={(e) => {
							handleClose();
							e.preventDefault();
							navigate(pageUrl);
							return false;
						}}
					>
						<ListItemIcon>
							<OpenInFullIcon sx={{ color: "black" }} />
						</ListItemIcon>
						<ListItemText>Full Screen</ListItemText>
					</MenuItem>
				}
				<ShowHideProvisionColumnsButton
					availableColumns={props.availableColumns}
					selectedColumns={props.selectedColumns}
					onColumnToggled={props.onColumnToggled}
					onClick={handleClose}
				/>
				<MenuItem
					color="secondary"
					id="hidden-rows-button"
					onClick={onToggleHiddenRows}
				>
					<ListItemIcon>
						{props.showHiddenRows ? (
							<VisibilityOffIcon sx={{ color: "black" }} />
						) : (
							<VisibilityIcon sx={{ color: "black" }} />
						)}
					</ListItemIcon>
					<ListItemText>
						{(props.showHiddenRows ? "Hide" : "Show") +
							" hidden rows"}
					</ListItemText>
				</MenuItem>
			</Menu>
		</div>
	);
}
